import axios from 'axios'
import {obtenerApiUrl} from '../config'
import {getMsalInstance, getLoginContext} from '../msalService'

let restApi = null

const initializeRestApi = async () => {
  const apiConfig = await obtenerApiUrl()
  restApi = axios.create({
    baseURL: apiConfig,
  })
}

const getRestApi = async () => {
  if (!restApi) {
    await initializeRestApi()
  }
  return restApi
}

let idToken = '...'

const getAccountInfo = () => {
  const accounts = getMsalInstance().getAllAccounts()
  return accounts[0]
}

const refreshAccessToken = async () => {
  const account = getAccountInfo()
  try {
    const scopes = getLoginContext().scopes
    const token = await getMsalInstance().acquireTokenSilent({
      account,
      scopes: scopes,
    })
    idToken = token.idToken
    return token.accessToken
  } catch (error) {
    return getMsalInstance()
      .acquireTokenRedirect(getLoginContext())
      .then((resp) => {
        return resp.accessToken
      })
      .catch((err) => {
        console.log(err)
      })
  }
}

export {getRestApi, refreshAccessToken, getAccountInfo, idToken}
